import { useQuery } from '@tanstack/react-query'
import { purchaseOrdersRHService } from '@/features/rh/api/purchaseOrdersRH.service'

/**
 * Llave de caché del detalle de una orden.
 *
 * Se exporta para que quien invalide use exactamente la misma: había cinco
 * nombres distintos de llave para órdenes de compra en la app, y esta pantalla
 * invalidaba `purchase-order`, que no existe en ninguna parte. El resultado era
 * que liberar líneas guardaba bien y la pantalla nunca se enteraba.
 */
export const llaveDeOrden = (orderId: string) => ['purchaseOrder', orderId] as const

export const usePurchaseOrderDetail = (orderId: string) => {
  return useQuery({
    queryKey: llaveDeOrden(orderId),
    queryFn: () => purchaseOrdersRHService.getOrderById(orderId),
    enabled: !!orderId
  })
}
